app.controller('FinalController', [
	'$anchorScroll',
	function($anchorScroll) {
		 $scope.$on('$viewContentLoaded', function(){
		    	$location.hash('scrollTo');
		        $anchorScroll();
		      });
		
  // sessionStorage.removeItem('registrationData')
}])
